import { FlagsRepository } from '../domain/repositories/flagsRepository'
import { FlagsDatasource } from './datasources/FlagsDatasource'

export function flagsRepositoryAdapter(
  datasource: FlagsDatasource
): FlagsRepository {
  return {
    async listFlags() {
      return await datasource.listFlags()
    },
    async updateAllFlags(data) {
      return await datasource.updateAllFlags(data)
    }
  }
}
